module.exports = __webpack_public_path__ + "img/1f52d.3ffa7bb.svg";